var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoContracts = function SvgNoContracts(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9E4B7",
    d: "M27.077 44.485l-16.53 16.53c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.687 12.285 4.687 16.971 0l16.53-16.53L60.95 78.359c4.686 4.686 12.284 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97L61.018 44.484l16.03-16.03c4.686-4.685 4.686-12.283 0-16.97-4.687-4.686-12.285-4.686-16.97 0l-16.03 16.03-15.03-15.03c-4.686-4.686-12.284-4.686-16.97 0-4.687 4.687-4.687 12.285 0 16.97l15.03 15.03z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.562,
    cy: 70,
    r: 12,
    fill: "#FFD67C",
    transform: "matrix(-1 0 0 1 37.125 0)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoContracts);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MCIgaGVpZ2h0PSI5MCIgdmlld0JveD0iMCAwIDkwIDkwIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNGOUU0QjciIGQ9Ik0yNy4wNzcgNDQuNDg1bC0xNi41MyAxNi41M2MtNC42ODYgNC42ODYtNC42ODYgMTIuMjg0IDAgMTYuOTcgNC42ODcgNC42ODcgMTIuMjg1IDQuNjg3IDE2Ljk3MSAwbDE2LjUzLTE2LjUzTDYwLjk1IDc4LjM1OWM0LjY4NiA0LjY4NiAxMi4yODQgNC42ODYgMTYuOTcgMCA0LjY4Ny00LjY4NiA0LjY4Ny0xMi4yODQgMC0xNi45N0w2MS4wMTggNDQuNDg0bDE2LjAzLTE2LjAzYzQuNjg2LTQuNjg1IDQuNjg2LTEyLjI4MyAwLTE2Ljk3LTQuNjg3LTQuNjg2LTEyLjI4NS00LjY4Ni0xNi45NyAwbC0xNi4wMyAxNi4wMy0xNS4wMy0xNS4wM2MtNC42ODYtNC42ODYtMTIuMjg0LTQuNjg2LTE2Ljk3IDAtNC42ODcgNC42ODctNC42ODcgMTIuMjg1IDAgMTYuOTdsMTUuMDMgMTUuMDN6Ii8+PGNpcmNsZSBjeD0iMTguNTYyIiBjeT0iNzAiIHI9IjEyIiBmaWxsPSIjRkZENjdDIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAzNy4xMjUgMCkiLz48L2c+PC9zdmc+";